import en from 'locales/en.json';
import kk from 'locales/kk.json';
import ru from 'locales/ru.json';

import { Locales } from '../constants/app';

interface ILocales {
  [key: string]: string;
}

const getIntlMessages = (locale: string): ILocales => {
  if (locale === Locales.kk) return kk;

  if (locale === Locales.en) return en;

  return ru;
};

export { getIntlMessages };
